import { MessageToken } from '../interfaces/message-token';
import {UntokenizedMessage} from '../models/untokenized-message';
import {LinkItem} from '../interfaces/link-item';

// export enum PdsMessageType {
//   // Floating Messages [0,50)
//   SUCCESS = 0,
//   INFO = 1,
//   WARNING = 2,
//   ERROR = 3,
//   // Docked Messages [50, 100)
//   SUCCESS_DOCKED = 50,
//   INFO_DOCKED = 51,
//   WARN_DOCKED = 52,
//   ERROR_DOCKED = 53,
//   // Dialog Messages [100, 150)
//   SUCCESS_DIALOG = 100,
//   INFO_DIALOG = 101,
//   WARN_DIALOG = 102,
//   ERROR_DIALOG = 103
// }

export type PdsMessageType = 'SUCCESS' | 'INFO' | 'WARNING' | 'ERROR';
export type PdsMessageLocation = 'FLOATING' | 'DOCKED' | 'INLINE';

export class Message {

  get isTypeSuccess(): boolean {
    return this.type === 'SUCCESS';
  }

  get isTypeInfo(): boolean {
    return this.type === 'INFO';
  }

  get isTypeWarning(): boolean {
    return this.type === 'WARNING';
  }

  get isTypeError(): boolean {
    return this.type === 'ERROR';
  }

  timeoutObj: any;
  timeoutOccurred = false;
  dismissId: string;
  message = '';
  tokens: MessageToken[];
  hasLinks = false;
  type: PdsMessageType;
  location: PdsMessageLocation;
  timeout = 3000;
  channel = 'default';
  private untokenizedMessage: string | UntokenizedMessage;

  constructor (type: PdsMessageType,
               location: PdsMessageLocation,
               untokenizedMessage: string | UntokenizedMessage,
               timeout?: number,
               channel?: string) {
    this.type = type;
    this.location = location;
    if (typeof timeout === 'number') {
      this.timeout = timeout;
    }

    if (typeof channel === 'string') {
      this.channel = channel;
    }

    this.tokens = this.tokenizeMessage(untokenizedMessage);
    for (let token of this.tokens) {
      if (token.isLinkItem && token.linkItem != null) {
        let linkItem = token.linkItem;
        this.message = this.message + linkItem.name;
        this.timeout = 0;
      } else if (typeof token.message === 'string') {
        this.message = this.message + token.message;
      }
    }
    this.dismissId = `${this.channel}-${this.type}-${this.location}-${this.message.length}-dismiss`;
  }

  /**
   * Takes a string containing html tags, splits it and returns tokenized messages.
   * @param unMessageToken - message containing the html tags and a list of link items
   * that corresponds to the tags.
   */

  private tokenizeMessage(untokenizedMessage: string | UntokenizedMessage): MessageToken[] {

    if (typeof untokenizedMessage === 'string') {
      return [{
        isLinkItem: false,
        message: untokenizedMessage
      }];
    } else if (untokenizedMessage.links == null || (untokenizedMessage.links != null && untokenizedMessage.links.length < 1)) {
      return [{
        isLinkItem: false,
        message: untokenizedMessage.message
      }];
    } else {
      this.hasLinks = true;
      let message = untokenizedMessage.message;
      // this is the regex to filter out all tags: /(<\s*.+?[^>]*>.*?<\s*\/\s*.+?>)/g
      // since we only display anchors in the template. I'm choosing to specifically look for them
      let htmlRegex = /(<a.+?[^>]*>[^<]*<\/a>)/g;
      let splitTokens: string[] = message.split(htmlRegex); // WOOO I LOVE REGEXs
      let messageTokens: MessageToken[] = [];
      for (let token of splitTokens) {
        // regular string token
        if (token.trim().charAt(0) !== '<') {
          messageTokens.push({
            isLinkItem: false,
            message: token
          });
        } else {
          let temporaryElement = document.createElement('div');
          temporaryElement.innerHTML = token.trim();
          let htmlToken = <HTMLElement>temporaryElement.firstChild;
          // if there is a html tag embedded in the string, then we want a link item for that tag.
          // that will be done by associating the id of the tag to the id of the link item
          let relatedLinkItem = untokenizedMessage.links.filter((linkItem: LinkItem) => {
            return htmlToken.id === linkItem.id;
          })[0];
          if (relatedLinkItem == null) {
            console.error(`Link with id '${htmlToken.id}' not found in provided LinkItem array.`);
          }
          messageTokens.push({
            isLinkItem: true,
            message: htmlToken.innerText,
            linkItem: relatedLinkItem
          });
        }
      }
      return messageTokens;
    }
  }
}
